/** When your lang table is too long, you can split it into small modules**/


const constant = {
  defaultPrice: "默认价格",//默认价格
  day: "天",//天
  inactivated: "未激活",//未激活
  activation: "激活",//激活
  month: "月",//月
  maturity: "到期",
  use: "使用",//使用
  orderId: "订单号",//订单号
  function: "功能",//功能
  hide: "隐藏",
  piece: "个",// 个

  status: {
    text: {
      map: {
        create: "提交",
        edit: "更新"
      }
    },
    option: [
      { label: "正常", code: 1 },
      // { label: "欠费", code: 2 },
      { label: "暂停", code: 3 }
    ],
    terminalOption: [
      { label: "正常", code: 1 },
      /*{ label: "正常", code: 2 },*/
      { label: "暂停", code: 3 },
      { label: "终止", code: 4 }
    ],
    broadcast: {
      1: "正常",
      2: "暂停"
    },
    online: {
      true: "在线",
      false: "离线"
    },
    orderStatus: {
      Expiring_Soon: "即将到期",
      Expired: "已经过期",
    },

    map: {
      1: "正常",
      2: "正常",
      3: "暂停",
      4: "终止"
    },

    patrol: {
      map: {
        1: "NFC巡更",
        2: "GPS巡更",
        3: "NFC巡更预设",
      },
      option: [
        { label: "NFC巡更", code: 1 },
        { label: "GPS巡更", code: 2 },
        { label: "NFC巡更预设", code: 3 },
      ],

      eventFlag: {
        0: "未知类型",
        1: "有效打卡",
        2: "无效打卡",
      },

      sign: {
        0: "已删除",
        1: "是",
        2: "否",
      },

      timezone: [
        { label: "GMT+14:00", code: 14 },
        { label: "GMT+13:00", code: 13 },
        { label: "GMT+12:00", code: 12 },
        { label: "GMT+11:00", code: 11 },
        { label: "GMT+10:00", code: 10 },
        { label: "GMT+9:00", code: 9 },
        { label: "GMT+8:00", code: 8 },
        { label: "GMT+7:00", code: 7 },
        { label: "GMT+6:00", code: 6 },
        { label: "GMT+5:00", code: 5 },
        { label: "GMT+4:00", code: 4 },
        { label: "GMT+3:00", code: 3 },
        { label: "GMT+2:00", code: 2 },
        { label: "GMT+1:00", code: 1 },
        { label: "GMT+0:00", code: 0 },
        { label: "GMT-12:00", code: -12 },
        { label: "GMT-11:00", code: -11 },
        { label: "GMT-10:00", code: -10 },
        { label: "GMT-9:00", code: -9 },
        { label: "GMT-8:00", code: -8 },
        { label: "GMT-7:00", code: -7 },
        { label: "GMT-6:00", code: -6 },
        { label: "GMT-5:00", code: -5 },
        { label: "GMT-4:00", code: -4 },
        { label: "GMT-3:00", code: -3 },
        { label: "GMT-2:00", code: -2 },
        { label: "GMT-1:00", code: -1 },
      ],

      statusMap: {
        1: "激活",
        2: "暂停",
      },

      typeMap: {
        1: "日计划",
        2: "周计划",
        3: "自定义计划",
      },

      timezoneMap: {
        14: "GMT+14:00",
        13: "GMT+13:00",
        12: "GMT+12:00",
        11: "GMT+11:00",
        10: "GMT+10:00",
        9: "GMT+9:00",
        8: "GMT+8:00",
        7: "GMT+7:00",
        6: "GMT+6:00",
        5: "GMT+5:00",
        4: "GMT+4:00",
        3: "GMT+3:00",
        2: "GMT+2:00",
        1: "GMT+1:00",
        0: "GMT+0:00",
        "-12": "GMT-12:00",
        "-11": "GMT-11:00",
        "-10": "GMT-10:00",
        "-9": "GMT-9:00",
        "-8": "GMT-8:00",
        "-7": "GMT-7:00",
        "-6": "GMT-6:00",
        "-5": "GMT-5:00",
        "-4": "GMT-4:00",
        "-3": "GMT-3:00",
        "-2": "GMT-2:00",
        "-1": "GMT-1:00",
      },

      week: [
        { label: "周一", code: "1" },
        { label: "周二", code: "2" },
        { label: "周三", code: "3" },
        { label: "周四", code: "4" },
        { label: "周五", code: "5" },
        { label: "周六", code: "6" },
        { label: "周日", code: "7" },
      ],

      func: [
        { label: "图片", code: "1" },
        { label: "语音", code: "2" },
        { label: "视频", code: "3" },
        { label: "位置", code: "4" },
      ],

      funcMap: {
        1: "图片",
        2: "语音",
        3: "视频",
        4: "位置",
      },

      weekMap: {
        "1": "周一",
        "2": "周二",
        "3": "周三",
        "4": "周四",
        "5": "周五",
        "6": "周六",
        "7": "周日",
      },

      signMap: {
        1: "执勤执法",
        2: "事故处理",
        3: "现场执法",
      },

      signOption: [
        { label: "执勤执法", code: "1" },
        { label: "事故处理", code: "2" },
        { label: "现场执法", code: "3" },
      ],

    },

    accountType: [
      { label: "普通", code: 0 },
      { label: "终身免费", code: 3 }
    ]
  },
  groupStatus: {
    option: [
      { label: "正常", code: "1" },
      { label: "暂停", code: "3" }
    ],
    map: {
      1: "正常",
      3: "暂停"
    }
  },
  groupType: {
    option: [
      { label: "普通群组", code: 1 },
      { label: "固定群组", code: 4, disabled: true },
      { label: "面对面组", code: 5, disabled: true }
      // { label: "临时组", code: 2 },
      // { label: "嵌套组", code: 3 }
    ],
    map: {
      1: "普通群组",
      2: "临时组",
      3: "嵌套组",
      4: "固定群组",
      5: "面对面组"
    }
  },
  qbOperationType: {
    select: "{type,select,1{划分} other{回收} }",
    option: [
      { label: "Division", code: 1 },//划分
      { label: "Recycling", code: 2 }//回收
    ]
  },
  onlineStatus: {
    option: [
      { label: "在线", code: 0 },
      { label: "离线", code: 1 }
    ],
    map: {
      true: "在线",
      false: "离线"
    }
  },
  talkieLevel: [
    { label: "低", code: 0 },
    { label: "中", code: 1 },
    { label: "高", code: 2 },
    { label: "特高", code: 3 }
  ],
  functions: [
    { label: "单呼", code: "1" },//单呼
    { label: "定位", code: "2" },//定位
    { label: "好友", code: "3" },//好友
    { label: "录音", code: "4" },//录音
    { label: "建组", code: "5" },//终端群组
    { label: "多呼", code: "6" },//多呼
    { label: "监听", code: "7" },//监听
    { label: "调度", code: "8" },//调度
    { label: "广播", code: "9" },//广播
    { label: "面对面组群", code: "10" },//面对面组群
    { label: "SOS报警", code: "11" },//SOS报警
    { label: "视频", code: "12" }//SOS报警
  ],
  //季度
  season: [
    { label: "1~3月", code: 1 },//第一季度  13
    { label: "4~6月", code: 2 },//第二季度
    { label: "7~9月", code: 3 },//第二季度
    { label: "10~12月", code: 4 }//第二季度
  ],

  functs: "{functs,select,1{单呼、} 2{定位、} 3{好友、} 4{录音、} 5{建组、} 6{多呼、} 7{监听、} 8{调度、} 9{广播、} 10{面对面组群、} 11{SOS报警、} 12{视频、} other{}}",
  organization: "{organization,select,1{调度、} 2{定位、} 3{对讲、} 4{群组、} 5{地图、} 8{调度、} 9{广播、}  12{视频、} other{}}",
  patrolWeek: "{patrolWeek,select,1{周一、} 2{周二、} 3{周三、} 4{周四、} 5{周五、} 6{周六、} 7{周日、} other{}}",
  taskFunc: "{taskFunc,select,1{图片、} 2{音频、} 3{视频、} 4{位置、}other{}}",
  null: "暂无",
  levelops: [
    {
      value: '0',
      label: '低'
    }, {
      value: '1',
      label: '中',
    }, {
      value: '2',
      label: '高'
    }, {
      value: '3',
      label: '特高'
    },
  ],
  extend_levelops: [
    {
      value: '4',
      label: '特高1'
    }, {
      value: '5',
      label: '特高2',
    }, {
      value: '6',
      label: '特高3'
    }, {
      value: '7',
      label: '特高4'
    },
    {
      value: '8',
      label: '特高5'
    }, {
      value: '9',
      label: '特高6',
    },
  ]


};


export default constant;



// WEBPACK FOOTER //
// ./src/api/lang/modules/constant/constant_en.js